import { IconProps } from '../ui/Icon/types';
import Icon from '../ui/Icon';

export default function IconCloseCircle(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <path
        d="M16.002 2.667c-7.373 0-13.333 5.96-13.333 13.333s5.96 13.333 13.333 13.333c7.373 0 13.333-5.96 13.333-13.333s-5.96-13.333-13.333-13.333zM16.002 26.667c-5.88 0-10.667-4.787-10.667-10.667s4.787-10.667 10.667-10.667 10.667 4.787 10.667 10.667c0 5.88-4.787 10.667-10.667 10.667zM20.789 9.334l-4.787 4.787-4.787-4.787-1.88 1.88 4.787 4.787-4.787 4.787 1.88 1.88 4.787-4.787 4.787 4.787 1.88-1.88-4.787-4.787 4.787-4.787-1.88-1.88z"
        fill="currentColor"
      />
    </Icon>
  );
}
